import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
//import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    //private ga: GoogleAnalytics
  ) {
    this.initializeApp();
    this.darkMode();
  }

  darkMode() {
    // Use matchMedia to check the user preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

    toggleDarkTheme(prefersDark.matches);

    // Listen for changes to the prefers-color-scheme media query
    prefersDark.addListener((mediaQuery) => toggleDarkTheme(mediaQuery.matches));

    // Add or remove the "dark" class based on if the media query matches
    function toggleDarkTheme(shouldAdd: boolean) {
      document.body.classList.toggle('dark', shouldAdd);
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      // this.ga.startTrackerWithId('G-L2HDZP8WRZ')
      //   .then(() => {
      //     console.log('Google analytics is ready now');
      //     this.ga.trackEvent('App', 'load', 'enya');
      //     // Tracker is ready
      //     // You can now track pages or set additional information such as AppVersion or UserId
      //   })
      //   .catch(e => console.log('Error starting GoogleAnalytics', e));
    });

    // setTimeout(() => {
    //   this.preloadAssets();
    // }, 1500);


  }
  preloadAssets() {

    var images1 = [
      "../assets/imgs/preshow-1.png",
      "../assets/imgs/warning.png",
      "../assets/imgs/teatro-ad.gif",
      "../assets/imgs/chimes-a-word.png",
      "../assets/imgs/chimes-begin-in-one.png",
      "../assets/imgs/chimes-begin-in-two.png",
      "../assets/imgs/chimes-curtains-up.png",
      "../assets/imgs/chimes-show-start-soon.png",
    ]
    var images2 = [
      "../assets/imgs/morning/atom.gif",
      "../assets/imgs/morning/blaise.gif",
      "../assets/imgs/morning/hala.gif",
      "../assets/imgs/morning/kessy.gif",
      "../assets/imgs/morning/lucy.gif",
      "../assets/imgs/morning/mimi.gif",
      "../assets/imgs/morning/berke.gif",
      "../assets/imgs/morning/atom-done.gif",
      "../assets/imgs/morning/blaise-done.gif",
      "../assets/imgs/morning/hala-done.gif",
      "../assets/imgs/morning/kessy-done.gif",
      "../assets/imgs/morning/lucy-done.gif",
      "../assets/imgs/morning/mimi-done.gif",
      "../assets/imgs/morning/berke-done.gif",
    ]

    var videos1 = [
      "../assets/imgs/inqpop.m4v",
      "../assets/imgs/kinderpop.m4v",
      "../assets/imgs/astig.m4v",
      "../assets/imgs/canb.m4v",
      "../assets/imgs/wim.m4v"
    ];
    var videos2 = [];

    // load all batch 1 images
    images1.forEach((src1, index) => {
      setTimeout(() => {
        this.preloadImage(src1);
      }, 300 * index);
    })
    // load all batch 1 videos
    videos1.forEach((src2, index) => {
      setTimeout(() => {
        this.preloadVideo(src2);
      }, 300 * index);
    })
    // load all batch 2 images
    images2.forEach((src3, index) => {
      setTimeout(() => {
        this.preloadImage(src3);
      }, 300 * index);
    })
    // load all batch 2 videos
    videos2.forEach((src4, index) => {
      setTimeout(() => {
        this.preloadVideo(src4);
      }, 300 * index);
    })
  }

  preloadImage(source) {
    console.log('loading image', source)
    let img = new Image();
    img.src = source;
    img.style.visibility = "hidden";
  }

  preloadVideo(source, append = false) {
    console.log('loading video', source)
    var v = document.createElement("video");
    if (source != "") {
      v.src = source;
    }
    if (append == true) {
      document.body.appendChild(v);
    }

  }

}
